import { Injectable } from '@angular/core'
import { of } from 'rxjs'
import { shareReplay } from 'rxjs/operators'
import { AuthTokenService } from '../auth-token.service'

@Injectable()
export class MockAuthTokenService extends AuthTokenService {
  token = of({}).pipe(shareReplay(1))
  getAccessTokenSilently = of()
  user$ = of({}).pipe(shareReplay(1))
}
